import Vue from 'vue';
import VueLodash from 'vue-lodash';
import lodash from 'lodash';

Vue.use(VueLodash, { name: '$ld', lodash: lodash });
// use $ld, lodash or _ to using plugin vue lodash
